// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.lee-progress {\n  display: flex;\n  align-items: center;\n}\n.lee-progress-bar {\n  flex-grow: 1;\n  height: var(--h);\n  background-color: var(--bgcolor);\n  overflow: hidden;\n  border-radius: var(--bordius)\n}\n.lee-progress-inner-bar {\n  height: var(--h);\n  background-color: var(--atcolor);\n}\n.lee-progress-info {\n  flex-shrink: 0;\n  padding-left: 15px\n}\n\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
